import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IPageService } from "App/Modules/Services";

import { noop } from "lodash";
import type { ICoverageCalculationsService } from "App/Modules/Gui";
import type { IFunctionalityMonitoring, IMap, ISiteEquipmentWithCoverages } from "App/Modules/Models";
import { EquipmentFunctions } from "App/Modules/Models/Models/EquipmentFunctions";
import type { IResponseWithLoading } from "App/Modules/Models/Models/IResponseWithLoading";
import type { ISiteFunctionalitiesRepository, ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";
import type ISiteEquipmentListService from "../../../Services/EquipmentList/ISiteEquipmentListService";

export default class SiteEquipmentComponentController implements IComponentController {
    public static $inject: string[] = [
        "$scope",
        "irPageService",
        "mmSitesRepository",
        "mmSiteFunctionalitiesRepository",
        "mmCoverageCalculationsService",
        "irSiteEquipmentListService",
        "$translate",
    ];

    public siteId: string;

    public siteEquipmentList: IResponseWithLoading<ISiteEquipmentWithCoverages[]>;

    public map: IResponseWithLoading<IMap>;

    public functionalities: IResponseWithLoading<IFunctionalityMonitoring[]>;

    public filterEquipmentBy: any; // TODO: think about filtering and sorting options

    constructor(
        private readonly $scope: IScope,
        private readonly pageService: IPageService,
        private readonly sitesRepository: ISitesRepository,
        private readonly siteFunctionalitiesRepository: ISiteFunctionalitiesRepository,
        private readonly coverageCalculationsService: ICoverageCalculationsService,
        private readonly siteEquipmentListService: ISiteEquipmentListService,
        private readonly $translate: angular.translate.ITranslateService,
    ) {}

    public $onInit() {
        // TODO: refactor linking other entities to SiteEquipment
        extendWithLoadingAndFail(this.sitesRepository.getMap(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response) => {
                    this.map = response;
                    if (this.map.data) {
                        this.coverageCalculationsService.polygonToAbsolute(
                            this.map.data.scaleCoordinates,
                            this.map.data.image,
                        );
                    }
                },
                () => noop,
            );

        extendWithLoadingAndFail(this.siteEquipmentListService.fetchList(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<ISiteEquipmentWithCoverages[]>) => {
                    this.siteEquipmentList = response;
                },
                () => noop,
            );

        extendWithLoadingAndFail(this.siteFunctionalitiesRepository.getFunctionalitiesMonitoring(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe((response) => {
                this.functionalities = response;
                if (this.functionalities.data) {
                    this.siteEquipmentList.data.forEach((siteEquipment) => {
                        EquipmentFunctions.updateEquipmentWithFunctionality(siteEquipment, this.functionalities.data);
                    });
                }
            });
    }

    public getEquipmentSubcaption(siteEquipment: ISiteEquipmentWithCoverages): string {
        return siteEquipment.type
            ? `${this.$translate.instant(`Enums.EquipmentClass.${siteEquipment.type.className}`)}, ${
                  siteEquipment.type.model
              }`
            : this.$translate.instant(`Enums.EquipmentClass.${siteEquipment.className}`);
    }
}
